import { render } from "./MegaNotice.vue?vue&type=template&id=37f6b45a&scoped=true"
import script from "./MegaNotice.vue?vue&type=script&lang=js"
export * from "./MegaNotice.vue?vue&type=script&lang=js"

import "./MegaNotice.vue?vue&type=style&index=0&id=37f6b45a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f6b45a"]])

export default __exports__